export default __webpack_public_path__ + "static/media/fw-mia-er-White Gold.579c39c2.mp4";